export const maskAccountNumber = (num: string, visibleDigits: number = 4) => {
  if (!num) return "";
  if (num.length <= visibleDigits) return num;

  const visible = num.slice(-visibleDigits);
  const maskedLength = num.length - visibleDigits;
  const masked = "*".repeat(maskedLength);

  return masked + visible;
};

// export const maskAccountNumber = (num: string) => {
//   if (!num) return "";
//   if (num.length <= 4) return num; // don’t mask very short numbers
//   const visible = num.slice(-4);
//   return "************ " + visible;
// };
